export default "__VITE_ASSET__BnH6dbyN__"